import { BarsLoader } from '@insight-health-ai/roseate/components';
import classNames from 'classnames';

type ScreenLoaderProps = {
  className?: string;
};

export const ScreenLoader = ({ className }: ScreenLoaderProps) => {
  return (
    <div
      className={classNames(
        'flex h-full w-full flex-col gap-2 overflow-hidden items-center justify-center',
        className
      )}
    >
      <BarsLoader />
    </div>
  );
};
